import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Image from "next/image";
import CustomText from "./text";
import { useI18n } from "@/i18n/I18nProvider";

const BASE_SX = {
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  width: "100%",
  padding: "10px 26px",
  borderRadius: "70px",
  overflow: "hidden",
  backgroundColor: "#fff",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "70px",
    opacity: 0.3,
    pointerEvents: "none",
  },
};

function IconWithText({ item }) {
  const { locale } = useI18n();
  const isArabic = locale === "ar";
  const sx = useMemo(() => {
    const gradient = isArabic
      ? "linear-gradient(270deg, #D2D2D2 0%, rgba(210, 210, 210, 0) 100%)"
      : "linear-gradient(90deg, #D2D2D2 0%, rgba(210, 210, 210, 0) 100%)";

    return {
      ...BASE_SX,
      "&::before": { ...BASE_SX["&::before"], background: gradient },
    };
  }, [isArabic]);
  //no type from db
  return (
    <Box sx={sx}>
      <Image
        src={item?.icon}
        alt={item?.text}
        width={40}
        height={40}
        sizes="40px"
        loading="lazy"
      />

      <Box>
        <CustomText
          variant="body2"
          text={item?.title}
          type="md"
          customStyle={{ fontWeight: 600, color: "#00195A" }}
          enableHtml={true}
        />

        {item?.desc ? (
          <CustomText
            variant="body2"
            text={item?.desc}
            type="xxs"
            customStyle={{ mt: 0.5 }}
          />
        ) : null}
      </Box>
    </Box>
  );
}

export default memo(IconWithText);
